export const RECIVING = [
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.IN_BRANCH',
    value: 1,
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.FROM_OFFICE',
    value: 0,
  },
];
export const RECIVING_MAP = new Map<number, string>(
  RECIVING.map((item) => [item.value, item.label]) as any
);
